module.exports = __webpack_public_path__ + "static/media/FAQ.67c2ca70.pdf";